(function($) {

    $(window).on('load', function() {

        if($('.select').length > 0) {


        }

        if($('.menuLink.products').length > 0) {
            $(document).on('click', '.menuLink.products', function(e){
                if($('.home').length > 0){
                    e.preventDefault();
                    e.stopPropagation();
                    $('.menu').removeClass('active');
                    $('body').removeClass('popupOpened');
                    setTimeout(function(){
                        $('.menu').removeClass('active');
                        $('body').removeClass('popupOpened');
                    },500);
                    $('.menuClose').click();
                    $('html, body').animate({
                        scrollTop: $('#products').offset().top - parseInt((window.innerHeight - $('#products').outerHeight()) / 2, 10)
                    }, 300);
                } else {
                }
            });

            if(window.location.hash) {
                $('html, body').animate({
                    scrollTop: $(window.location.hash).offset().top - parseInt((window.innerHeight - $(window.location.hash).outerHeight()) / 2, 10)
                }, 300);

            }

        }



        if($('.select').length > 0) {
            $('.select').each(function(){
                var thisEl = $(this);
                var thisPlaceholder = thisEl.parents('.selectBlock').attr('data-placeholder');
                var dClass = "cdc";
                var select = $(this).select2({
                    dropdownAutoWidth: true,
                    width: '100%',
                    height: '163px',
                    placeholder: thisPlaceholder,
                    minimumResultsForSearch: 1,
                    dropdownCssClass: dClass
                });
            });

            $(document).on('change click', '.select', function(){
                if($(this).parents('.selectBlock').hasClass('err')) {
                    $('.selectBlock').removeClass('err');
                }
            })
        }


        $(document).on('click', '.whereToBuyItem', function(e){
            var thisEl = $(this);
            var thisSlug = thisEl.attr('data-country');
            var thisLatitude = parseFloat(thisEl.attr('data-latitude'));
            if($(window).width() > 1024) {
                var thisLongitude = parseFloat(thisEl.attr('data-longitude')) - 6;
            } else {
                var thisLongitude = parseFloat(thisEl.attr('data-longitude'));
            }
            if(thisEl.hasClass('active')) {
                thisEl.removeClass('active');
                map.flyTo({
                    center: [-32.9898557, 40.7446298],
                    zoom: 3,
                    bearing: 0,
                });
            } else {
                $('.whereToBuyItem').not(thisEl).removeClass('active');
                thisEl.addClass('active');
                // map.setView([thisLatitude, thisLongitude], 12);
                map.flyTo({
                    center: [thisLongitude, thisLatitude],
                    zoom: 5,
                    bearing: 0,
                });
            }
        });


        if($('.ageVerificationIfNot').length > 0) {
            $(document).on('click', '.ageVerificationButton--back', function(){
                var thisClick = $(this);
                var parentHolder = thisClick.parents('.ageVerificationIfNot');
                var mainHolder = thisClick.parents('.ageVerification');
                var cookiesHolder = mainHolder.find('.ageVerificationContent');
                eraseCookie('age');
                parentHolder.fadeOut(300, function(){
                    cookiesHolder.fadeIn(300);
                })
            });
        }

        function eraseCookie(name) {
            document.cookie = name+'=; Max-Age=0';
        }

        var sync2 = $(".carousel_2");
        $(sync2).owlCarousel({
            nav: false,
            loop:true,
            margin:32,
            center:true,
            autoWidth: true,
        }).on('changed.owl.carousel', function(event) {
            setTimeout(function(){
                sync2.find('.owl-item.current').removeClass('current');
                sync2.find('.owl-item.prevCurrent').removeClass('prevCurrent');
                sync2.find('.owl-item.nextCurrent').removeClass('nextCurrent');
                var current = sync2.find('.owl-item.active.center').length ? sync2.find('.owl-item.active.center') : sync2.find('.owl-item.active').eq(0);
                current.addClass('current');
                current.prev().addClass('prevCurrent');
                current.next().addClass('nextCurrent');
                // current.css('width', '340px');
                // current.prev().css('width', '290px');
                // current.next().css('width', '290px');
                // if(!($('.owl-item').hasClass('prevCurrent')) && !($('.owl-item').hasClass('prevCurrent')) && !($('.owl-item').hasClass('current'))) {
                //     $('.owl-item').css('width', '220px')
                // }
            }, 100);

        });


        setTimeout(function(){
            $('section.menu').removeAttr('style');
        }, 300);


        $(document).on('click', '.scrollTo', function(){
            var thisEl = $(this);
            var toEl = thisEl.data('to');
            if(thisEl.attr('data-minus')) {
                var minus = parseInt(thisEl.attr('data-minus'));
            } else {
                var minus = 0;
            }
            var el = $('.' + toEl);
            $('html, body').animate({
                scrollTop: $(el).offset().top - minus
            }, 500);
        });

        $(document).on('click', '.faqItem', function (){
            var thisEl = $(this);
            if(thisEl.hasClass('activeNew')) {
                thisEl.find('.faqAnswer').slideUp(300);
                thisEl.removeClass('activeNew');
            } else {
                thisEl.find('.faqAnswer').slideDown(300);
                thisEl.addClass('activeNew');
            }
        });

        $(document).on('mouseenter', '.coctailBarItem', function(){

        });
        $(document).on('mouseover', '.coctailBarItem', function(){

        });


        $(document).on('mouseenter', '.coctailBarItem, .coctailTasteItem', function () {
            $(this).find("video")[0].play();
            var el = $(this).find("video")[0];
        });
        $(document).on('mouseleave', '.coctailBarItem, .coctailTasteItem', function () {
            var el = $(this).find("video")[0];
            el.pause();
            el.currentTime = 7;
        });





        selectedProjectSlider();
        function selectedProjectSlider() {
            var sliderCount = $('.coctailBarCoctailsSlider .coctailBarItem').length;
            if (sliderCount > 1) {

                var coctailBarCoctailsSlider = cocktailSlider();

                $(document).on('click', '.cocktailsType', function (){
                    if(!($(this).hasClass('active'))) {
                        $('.cocktailsType').not($(this)).removeClass('active');
                        $(this).addClass('active');
                        changeCategory($(this));
                    }
                });

                function changeCategory(thisEl) {
                    var thisEl = thisEl;
                    var thisSlug = thisEl.data('tequila')
                    var pd;

                    var loader = $('<div class="loader"></div>');
                    var loaderHolder = $('<div class="loader__holder"></div>');
                    var loaderLoad = $('<div class="loader--load"></div>');

                    loader.append(loaderHolder);
                    loaderHolder.append(loaderLoad);
                    $('body').append(loader);
                    setTimeout(function(){
                        loader.addClass('active');
                    }, 100);

                    pd = new FormData();
                    pd.append('action', 'change_cocktails');
                    pd.append('slug', thisSlug);
                    $.ajax({
                        type: 'POST',
                        url: postmpwp.ajax_url,
                        data: pd,
                        dataType: 'json',
                        contentType: false,
                        processData: false,
                        success: function (response) {
                            if (response.success) {
                                // $(window).scroll();
                                setTimeout(function() {
                                    loader.removeClass('active');
                                    setTimeout(function(){
                                        loader.remove();
                                    }, 1000);
                                }, 2000);
                                coctailBarCoctailsSlider.removeAllSlides();
                                coctailBarCoctailsSlider.appendSlide(response.data.html);
                                coctailBarCoctailsSlider.destroy();
                                coctailBarCoctailsSlider = cocktailSlider();
                                coctailBarCoctailsSlider.update();

                                setTimeout(function() {
                                    coctailBarCoctailsSlider.reInit();
                                }, 100);
                            }
                        }
                    });
                }

                function cocktailSlider(){
                    return new Swiper('.coctailBarCoctailsSlider', {
                        centeredSlides: true,
                        initialSlide: 1,
                        loop: true,
                        effect: 'slide',
                        speed: 400,
                        grabCursor: true,
                        observer: true,
                        breakpoints: {
                            320: {
                                slidesPerView: 1,
                            },
                            767: {
                                slidesPerView: 2,
                            },
                            1051: {
                                slidesPerView: 3,
                            },
                        },
                    });
                }
            }
        }

    });

    $(window).on('scroll', function () {

    });

    $(window).on('resize', function () {

    });


    if($('#map').length > 0) {
        mapboxgl.accessToken = 'pk.eyJ1IjoibWVkaWFwYXJrIiwiYSI6ImNrczh2eTVveDB6MnAyb3BzOGg4dG5uMG0ifQ.8N1DS0s6y4YshNUgHOcNGQ';
        var map = new mapboxgl.Map({
            container: 'map',
            style: 'mapbox://styles/mediapark/cksfq64a32vnn17nu2vuub5cd',
            center: [-32.9898557, 40.7446298],
            zoom: 3,
            scrollZoom: false,
        });

        map.on('load', function () {
            geojson.features.forEach(function (marker) {
                // create a HTML element for each feature
                var el = document.createElement('div');

                var icon = marker.properties.icon;
                el.style.cssText = 'background-image : url(' + icon + ')';
                var customClass = marker.type;
                el.className = 'marker' + ' ' + customClass + '-marker hidden';

                // var popup = new mapboxgl.Popup({ offset: 25 })
                //     .setText('Construction on the Washington Monument began in 1848.');
                // Crete inner div
                if (customClass != 'main') {
                    // var name = marker.properties.info;
                    // var min = marker.properties.min;
                    //     $(el).append($('<div class="info">' + '<div class="name">' + name + '</div>' + '<div class="min">' + min + ' min. ' + '</div> ' + '</div>'));
                    $(el).append($('<div class="info"></div>'));
                }

                // make a marker for each feature and add to the map
                new mapboxgl.Marker(el, {anchor: 'bottom'})
                    .setLngLat(marker.geometry.coordinates)
                    .addTo(map);


            });
        });

    }

})( jQuery );

// function getOffset(element)
// {
//     var bound = element.getBoundingClientRect();
//     var html = document.documentElement;
//
//     return {
//         top: bound.top + window.pageYOffset - html.clientTop,
//         left: bound.left + window.pageXOffset - html.clientLeft
//     };
// }